module.exports = __webpack_public_path__ + "static/media/location.969a32d2.svg";